import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=2d48fe80&scoped=true"
import script from "./ProjectIndex.vue?vue&type=script&lang=js"
export * from "./ProjectIndex.vue?vue&type=script&lang=js"
import style0 from "./ProjectIndex.vue?vue&type=style&index=0&id=2d48fe80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d48fe80",
  null
  
)

export default component.exports